// cart-drawer.js — Datafusion Agency Cart Drawer
(function () {
  const overlay = document.querySelector('.df-cart-overlay');
  const drawer = document.querySelector('.df-cart-drawer');
  const closeBtn = document.querySelector('.df-cart-drawer__close');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const checkoutBtn = document.querySelector('.df-cart-checkout-btn');
  const continueBtn = document.querySelector('.df-cart-continue-btn');
  const cartCount = document.querySelector('.df-header__cart-count');
  const cartBody = document.querySelector('.df-cart-drawer__body');
  const cartTotalAmount = document.querySelector('.df-cart-total-amount');

  function openCart() {
    overlay?.classList.add('is-open');
    drawer?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    overlay?.classList.remove('is-open');
    drawer?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    if (!cartBody) return;

    // Update count
    const count = cart.item_count;
    if (cartCount) {
      cartCount.textContent = count;
      cartCount.style.display = count > 0 ? 'block' : 'none';
    }

    // Update total
    if (cartTotalAmount) cartTotalAmount.textContent = formatMoney(cart.total_price);

    if (count === 0) {
      cartBody.innerHTML = `
        <div class="df-cart-drawer__empty">
          <div class="df-cart-drawer__empty-icon">🛒</div>
          <div class="df-cart-drawer__empty-title">Tu carrito está vacío</div>
          <div class="df-cart-drawer__empty-sub">Agrega productos para cotizar</div>
        </div>`;
      return;
    }

    cartBody.innerHTML = cart.items.map(item => `
      <div class="df-cart-item" data-key="${item.key}">
        <img class="df-cart-item__img" src="${item.image}" alt="${item.product_title}">
        <div class="df-cart-item__info">
          <div class="df-cart-item__title">${item.product_title}</div>
          <div class="df-cart-item__vendor">${item.vendor || 'Datafusion Agency'}</div>
          <div class="df-cart-item__price">${formatMoney(item.price)}/u</div>
        </div>
        <div class="df-cart-item__right">
          <div class="df-qty-row">
            <button class="df-qty-btn" data-action="decrease" data-key="${item.key}">−</button>
            <span class="df-qty-num">${item.quantity}</span>
            <button class="df-qty-btn" data-action="increase" data-key="${item.key}">+</button>
          </div>
          <div class="df-cart-item__total">${formatMoney(item.price * item.quantity)}</div>
          <button class="df-cart-item__remove" data-key="${item.key}">Quitar</button>
        </div>
      </div>`).join('');

    // Bind qty buttons
    cartBody.querySelectorAll('.df-qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        const newQty = btn.dataset.action === 'increase' ? item.quantity + 1 : item.quantity - 1;
        updateItem(key, newQty);
      });
    });

    cartBody.querySelectorAll('.df-cart-item__remove').forEach(btn => {
      btn.addEventListener('click', () => updateItem(btn.dataset.key, 0));
    });
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderCart(cart))
      .catch(console.error);
  }

  function updateItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then(r => r.json())
      .then(cart => renderCart(cart))
      .catch(console.error);
  }

  // Add to cart — intercept forms
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('[action*="/cart/add"]')) return;
    e.preventDefault();

    const data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data })
      .then(r => r.json())
      .then(() => { openCart(); fetchCart(); })
      .catch(console.error);
  });

  cartTriggers?.forEach(el => el.addEventListener('click', openCart));
  overlay?.addEventListener('click', closeCart);
  closeBtn?.addEventListener('click', closeCart);
  continueBtn?.addEventListener('click', closeCart);
  checkoutBtn?.addEventListener('click', () => { window.location.href = '/checkout'; });

  // Init count on load
  fetchCart();
})();
